import { useState } from "react"
import FolderIcon from "../../../../media/FolderIcon"
import { WorkflowGroupProps } from "./WorkflowGroup.types"
import EllipsisMenu from "../../../../components/EllipsisMenu/EllipsisMenu"
import "./WorkflowGroup.css"

const WorkflowGroup = (props: WorkflowGroupProps) => {

  const { 
    name,
    date,
    ellipsisMenu,
    onClick,
    isSelected,
    onSelect
  } = props
  const [showMenu, setShowMenu] = useState<boolean>(false)

  return (
    <div
      className={`workflow-group-container ${isSelected ? "workflow-group-selected" : ""}`}
      onClick={onSelect}
      onDoubleClick={() => onClick()}
    >
      <div className="group-name-container">
        <FolderIcon />
        <p>{name}</p>
      </div>

      <p>{date}</p>

      <div className="ellipsis-menu-container">
        <EllipsisMenu
          ellipsisMenu={
            {
              items: ellipsisMenu,
              showMenu: showMenu,
              onClick: () => setShowMenu(true),
              onHide: () => setShowMenu(false),
            }
          }
        />
      </div>
    </div>
  )
}

export default WorkflowGroup